// src/app/services/clipboard.service.ts
import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';
import { PlanogramDrop } from '../models/layout/planogram-drop';
import { PlanogramProduct } from '../models/layout/planogram-product';
import { PlanogramShelf } from '../models/layout/planogram-shelf';
import { PlanogramProductStack } from '../models/layout/planogram-product-stack';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {
  private copiedShelf: PlanogramShelf | null = null;
  private copiedDrop: PlanogramDrop | null = null;
  private copiedStack: PlanogramProductStack | null = null;
  private copiedProduct: PlanogramProduct | null = null;
  private lastCopyType: 'shelf' | 'drop' | 'product' | 'stack' | null = null;

  getProduct(): PlanogramProduct | null {
    return cloneDeep(this.copiedProduct);
  }

  hasCopiedProduct(): boolean {
    return this.copiedProduct !== null;
  }

  copyProduct(product: PlanogramProduct): void {
    this.copiedProduct = cloneDeep(product);
    this.lastCopyType = 'product';
  }

  getStack(): PlanogramProductStack | null {
    return cloneDeep(this.copiedStack);
  }

  hasCopiedStack(): boolean {
    return this.copiedStack !== null;
  }

  copyStack(stack: PlanogramProductStack): void {
    this.copiedStack = cloneDeep(stack);
    this.lastCopyType = 'stack';
  }

  getShelf(): PlanogramShelf | null {
    return cloneDeep(this.copiedShelf);
  }

  hasCopiedShelf(): boolean {
    return this.copiedShelf !== null;
  }

  copyShelf(shelf: PlanogramShelf): void {
    this.copiedShelf = cloneDeep(shelf);
    this.lastCopyType = 'shelf';
  }

  getDrop(): PlanogramDrop | null {
    return cloneDeep(this.copiedDrop);
  }

  hasCopiedDrop(): boolean {
    return this.copiedDrop !== null;
  }

  copyDrop(drop: PlanogramDrop): void {
    this.copiedDrop = cloneDeep(drop);
    this.lastCopyType = 'drop';
  }

  getLastCopyType(): 'shelf' | 'drop' | 'product' | 'stack' | null {
    return this.lastCopyType;
  }

  clear(): void {
    this.copiedShelf = null;
    this.copiedDrop = null;
    this.copiedProduct = null;
    this.lastCopyType = null;
  }
}